import React from "react";
import "./dwechome.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/footer";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";

const loan_img = require("../../assets/loan1.svg");
const loan_img1 = require("../../assets/loan2.svg");
const loan_img2 = require("../../assets/loan3.svg");
const loan_img3 = require("../../assets/loan4.svg");
const loan_img4 = require("../../assets/loan5.svg");
const loan_img5 = require("../../assets/loan6.svg");
const loan_img6 = require("../../assets/loan7.svg");

function EducationLoanMainPage(props) {
  return (
    <>
      <div>
        <div className="nav_container">
          <Navbar fromPage="educationloanmainpage" />
        </div>
        <section className="loan_main_section_container">
          <div className="section_immigration_under_container">
            <div className="section_header_for_loan_contianer">
              <p className="title_text_immigration">
                EDUCATION LOAN <br />
                ASSISTANCE
              </p>
              <p className="subtitle_text_immigration">
              Enjoy a hassle free education loan for your studies, 
              as DWEC brings you education loan assistance for a comforting experience
              </p>
            </div>
          </div>
        </section>
        <div className="main_container_couselling_page_section">
          <section className="education" id="edu"></section>

          <section className="edu-items">
            <div className="container">
              <h3>
                The maximum amount of loan an applicant is eligible for is
                determined by a variety of factors. These factors include, among
                others:
              </h3>

              <div className="itms bord center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img.default} alt="passport_img" />
                  </div>
                </figure>

                <h4>Credit Worthiness</h4>

                <p>
                  Creditworthiness is a factor determined by evaluating a
                  person’s credit history. Lenders check an individual's 
                  credit-worthiness to determine his/her ability to repay the loan on
                  time. This is done to minimize the risks associated with an
                  education loan. Individuals with a clean credit history tend
                  to get higher loan amounts and quicker approvals.
                </p>
              </div>

              <div className="itms center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img1.default} alt="passport_img" />
                  </div>
                </figure>

                <h4>Credit Score</h4>

                <p>
                  Credit score plays a crucial role in determining your
                  eligibility for loans, credit cards, etc. Timely payment of
                  credit card bills & EMIs on existing loans reflects positively
                  on your credit score and helps in improving your chances of
                  getting an education loan.
                </p>
              </div>

              <div className="clear"></div>

              <hr />

              <div className="itms bord center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img2.default} alt="passport_img" />
                  </div>
                </figure>

                <h4>Value of Collateral</h4>

                <p>
                  Education loan lenders generally ask for collateral for loans
                  exceeding Rs.7.5 Lakh to minimize their risk. In case a
                  borrower fails to pay the loan, the collateral is used to
                  recover the loan amount. Applicants who offer collateral of
                  good value stand a better chance of getting high amount of
                  education loans.
                </p>
              </div>

              <div className="itms center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img3.default} alt="passport_img" />
                  </div>
                </figure>

                <h4>Academic History of Student</h4>

                <p>
                  The academic track record of a student plays a very important
                  role while sanctioning the education loan. Meritorious
                  students with an exceptional academic background exhibit
                  seriousness towards their education & career and hence, have a
                  better chance of getting well-paying jobs in the future.
                </p>
              </div>

              <div className="clear"></div>

              <hr />

              <div className="itms bord center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img4.default} alt="passport_img" />
                  </div>
                </figure>

                <h4>Eligibility for education loan</h4>

                <ul>
                  <li>The applicant must be a citizen of India.</li>

                  <li>The applicant must be at least 18 years old.</li>

                  <li>The applicant must have a good academic background.</li>

                  <li>
                    Applicant should have procured admission to a recognized
                    foreign university or institution.
                  </li>
                </ul>
              </div>

              <div className="clear"></div>
            </div>
          </section>

          <section className="edu-items edu-items1bg">
            <div className="container">
              <h3 style={{ marginBottom: 20 }}>Types of education loans:</h3>

              <p>
                There are two types of education loans. Both the loans can be
                provided by public sector banks, private sector banks, and NBFCs
                with varying interests.
              </p>

              <div className="itms bord center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img5.default} alt="passport_img" />
                  </div>
                </figure>

                <h4>Secured loan</h4>

                <p>
                  A secured loan is given to an applicant who is eligible to pay
                  for collateral. These loans have low-interest rates & require
                  time for processing. But these loans have comparatively higher
                  chances of approval and do not require applicants to repay
                  the amount during his/her study period.
                  <br />
                  <br />
                  <br />
                </p>
              </div>

              <div className="itms center_contianer_read_more_section">
                <figure>
                  <div className="img_container_immigration">
                    <img src={loan_img6.default} alt="passport_img" />
                  </div>
                  {/* <img
                src="<?php echo base_url();?>public/front/images/edu-icon7.png "
                alt="img"
              /> */}
                </figure>

                <h4>Unsecured loans</h4>

                <p>
                  An unsecured loan does not require the applicant to pay
                  collateral for the loan. But these loans have higher interest
                  rates. The good thing about these kinds of loans is their
                  processing time is really quick. Aside from the advantage,
                  an unsecured loan has the least chance of getting approval and
                  requires the applicant to repay the amount during his/her
                  study period.
                </p>
              </div>

              <div className="clear"></div>
            </div>
          </section>

          <section className="edu-items">
            <div className="container">
              <h3 style={{ marginBottom: 20 }}>
                How we can help you in acquiring an education loan?
              </h3>

              <p style={{ marginBottom: 15 }}>
                We take into consideration the amount of time and energy one has
                to spend in order to take an education loan. So, we at DWEC,
                bring you a hassle-free application process. The steps of the
                same are as follows:
              </p>

              <div className="itms" style={{ width: "100%" }}>
                <ul>
                  <li>
                    Once our client completes the application process, we match
                    your profile to offer you the best loan according to your
                    eligibility and requirement.
                  </li>

                  <li>
                    Next, we finalize the lender with you and provide you with a list
                    of documents required. We then, take care of the whole loan
                    process and documentation.
                  </li>

                  <li>
                    Subsequently, we assist you in the disbursal of loans to the
                    university as per the schedule.
                  </li>
                </ul>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </div>
      </div>
      <InterestedSectionMain />

      <Footer />
    </>
  );
}

export default EducationLoanMainPage;
